import { PropsWithChildren } from 'react';
import { cn } from '@/lib/utils';
import Image from 'next/image';

type Props = PropsWithChildren & {
  srcSet?: string;
  imgSrc: string;
  className?: string;
  alt?: string;
};

export default function Banner({
  imgSrc,
  className,
  children,
  alt = 'Banner image',
}: Props) {
  return (
    <div className="relative margin-bottom-responsive">
      <div className="mx-auto">
        <div className="relative w-full h-[300px] desktop:h-[650px]">
          <Image
            src={imgSrc}
            alt={alt}
            fill
            priority
            className="w-full h-full object-cover"
            sizes="(max-width: 480px) 100vw, (max-width: 767px) 90vw, (max-width: 1280px) 80vw, 100vw"
          />
          <div
            className={cn(
              'absolute w-full h-[100%] bg-black/[.3] top-0 left-0',
              className,
            )}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
